export const AUTH_KEY_PREFIX = 'CognitoIdentityServiceProvider'

const EXPIRED = 'Expires=Thu, 01 Jan 1970 00:00:00 GMT; Max-Age=0'

function storage(): Storage | null {
  try {
    return globalThis.localStorage
  } catch {
    return null
  }
}

function purgeLocalStorage(prefix: string): string[] {
  const store = storage()
  if (!store) return []

  const doomed: string[] = []

  try {
    for (let index = 0; index < store.length; index += 1) {
      const key = store.key(index)
      if (key?.startsWith(prefix) === true) doomed.push(key)
    }

    for (const key of doomed) store.removeItem(key)
  } catch {
    return []
  }

  return doomed
}

function purgeCookies(prefix: string, domain: string): string[] {
  const doc = globalThis.document as Document | undefined
  if (!doc) return []

  const doomed: string[] = []

  try {
    for (const pair of doc.cookie.split(';')) {
      const name = pair.split('=')[0]?.trim() ?? ''
      if (name !== '' && name.startsWith(prefix)) doomed.push(name)
    }

    for (const name of doomed) {
      doc.cookie = `${name}=; Path=/; ${EXPIRED}`
      if (domain !== '') doc.cookie = `${name}=; Path=/; Domain=${domain}; ${EXPIRED}`
    }
  } catch {
    return []
  }

  return doomed
}

export function purgeResidualTokens(clientId: string, cookieDomain = ''): string[] {
  const prefix = `${AUTH_KEY_PREFIX}.${clientId}.`

  return [...purgeLocalStorage(prefix), ...purgeCookies(prefix, cookieDomain.trim())]
}
